import { render, staticRenderFns } from "./coal-match-detail.vue?vue&type=template&id=52b79b0e&"
import script from "./coal-match-detail.vue?vue&type=script&lang=js&"
export * from "./coal-match-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports